import { useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchRequestHistory } from './RequestHistorySlice';
import { RequestHistoryDataSelector } from './RequestHistoryDataSelector';

export function useRequestHistory(customerNumber: string) {
    return useGetSimpleApiData(
        fetchRequestHistory,
        RequestHistoryDataSelector,
        undefined,
        {
            params: { customerNumber },
        },
        undefined,
        !!customerNumber,
    );
}
